// standart react component
import React from 'react';
import './App.css';
import './index.css';

export default function TitlebarWithControls(props) {
    const title = props.title;
    const children = props.children;

    return (
        <div className="bg-blue-200 left-0 right-0 my-0 top-16 z-10">
            <div className="px-4 py-4 sm:px-6 lg:px-8">
              <div className="flex items-center justify-between">
                <dd className="lg:pl-72 pl-2 text-3xl font-bold text-gray-900 flex-shrink-0">{title}</dd>
                
                <dd className="text-left">
                  <div className="flex justify-end">
                    {children}
                  </div>
                </dd>
              </div>

              {/* <dd className="w-3/4 mb-6 px-8 text-left sm:table-cell">
                <input className="rounded-md border-0 px-2 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" aria-label="Date" type="date" value={log_date}/>
              </dd> */}
            </div>
        </div>
    )
}